import { render, staticRenderFns } from "./ReqTable.vue?vue&type=template&id=682732d7&"
import script from "./ReqTable.vue?vue&type=script&lang=js&"
export * from "./ReqTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports